import { defineRule, configure } from 'vee-validate';
import {
  required,
  email,
  length,
  confirmed,
  max,
  min,
  regex,
} from '@vee-validate/rules';

export default defineNuxtPlugin((app) => {
  const { $t } = app;

  const rulesMessages = {
    required: $t('requiredField'),
    max: $t('validate.max'),
    min: $t('validate.min'),
    email: $t('validate.email'),
    confirmed: $t('validate.confirmed'),
    length: $t('validate.length'),
    regex: $t('validate.regex'),
  };
  defineRule('required', required);
  defineRule('email', email);
  defineRule('length', length);
  defineRule('confirmed', confirmed);
  defineRule('max', max);
  defineRule('min', min);
  defineRule('regex', regex);

  configure({
    generateMessage: (context) => {
      return context.rule?.name && rulesMessages[context.rule?.name]
        ? rulesMessages[context.rule?.name]
        : 'Invalid input';
    },
  });
});
